import React, {Component, PropTypes} from 'react';
import { format } from '../../utils/string';
import { lang } from '../../strings';
import { trackEvent, NETWORK_SERVICES, LOAD } from '../../utils/analytics';

export default class NetworkServiceDialog extends Component {

   componentDidMount() {
      trackEvent(NETWORK_SERVICES, LOAD);
   }
   
   render() {
      let { networkService, onConfirm, onCancel } = this.props;
      let { description, enabled } = networkService;

      let actionText = enabled ? lang.networkServices.dialog.deactivate : lang.networkServices.dialog.activate;
      let title = actionText + ' ' + description;

      return (
         <div className="mp-popup-container">
            <div className="mp-popup-content">
               <a href="#" className="mp-close" onClick={onCancel}>&times;</a>
               <h2 className="h5 color-dark-blue">{title}</h2>
               <p>{format(lang.networkServices.dialog.intro, actionText.toLowerCase(), description)}</p>
               <div className="mp-block" style={{marginTop: 50}}>
                  <div className="mp-block-half">
                     <button type="button" className="mp-submit" onClick={onConfirm}>{actionText}</button>
                  </div>
                  <div className="mp-block-half">
                     <button type="button" className="mp-submit" onClick={onCancel}>{lang.networkServices.dialog.cancel}</button>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

NetworkServiceDialog.propTypes = {
   networkService: PropTypes.object.isRequired,
   onConfirm: PropTypes.func.isRequired,
   onCancel: PropTypes.func.isRequired
};